import Separator from 'components/Separator';
import './generalInfo.scss'

const GeneralInfo = ({ data }) => {

    const items = [
        {
            title: 'Property Type',
            value: data.property_type_display,
        },
        {
            title: 'Bedrooms',
            value: data.bedroom_count,
        },
        {
            title: 'Bathrooms',
            value: data.bathroom_count,
        },
        {
            title: 'Street',
            value: data.street_name,
        },
        {
            title: 'County',
            value: data.county,
        },
        {
            title: 'Lot Size',
            value: `${data.square_footage} Sq. Ft.`,
        },
        {
            title: 'Year Built',
            value: data.year_built,
        },
        {
            title: 'Acres',
            value: data.acreage,
        },
        {
            title: 'Stories',
            value: data.stories_total ? `${data.stories_total} Story` : 'None',
        },
        {
            title: 'Sale/Rent',
            value:  data.sale_rent.charAt(0).toUpperCase() + data.sale_rent.slice(1)
        }
    ]

    return (
        <div className='general-info-container'>
            <div className='overview'>
                <p className='header'>Overview</p>
                <Separator height={16} />
                <span className='description'>
                    {data.description}
                </span>

            </div>
            <Separator height={24} />
            <div className='details'>
                <p className='header'>Property Details</p>
                <Separator height={16} />
                <div className='items'>
                    {
                        items.map((item, index) => {
                            return (
                                <div className='item' key={index}>
                                    <p className='title'>{item.title}</p>
                                    <p className='value'>{item.value}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}


export default GeneralInfo;